export default __webpack_public_path__ + "static/media/customer-ic-balance-card.ebc950b1.svg";